// extracted by mini-css-extract-plugin
export var cancelButton = "_ou-5";
export var content = "_ou-3";
export var createButton = "_ou-6";
export var drawerContainer = "_ou-0";
export var footer = "_ou-2";
export var header = "_ou-1";
export var orderFormColumn = "_ou-4";